import Location from '@r6digital/rapidstor-types/react/entities/Location';
import { determineTextColor } from '@r6digital/rapidstor-types/react/util/Color';

export default class LocationSettings {
    location: Location;

    constructor(location: Location) {
        this.location = location;
    }

    /**
     * If location object has appearance set, apply to theme styling
     */
    injectSiteTheme(): void {
        this.location.skin.accentColours.primary &&
            document.documentElement.style.setProperty(
                '--rs-accent',
                this.location.skin.accentColours.primary
            );
        this.location.skin.mainColour &&
            document.documentElement.style.setProperty(
                '--rs-theme',
                this.location.skin.mainColour
            );
        this.location.skin.highlightColour &&
            document.documentElement.style.setProperty(
                '--rs-highlight',
                this.location.skin.highlightColour
            );
        this.location.skin.mainColour &&
            document.documentElement.style.setProperty(
                '--rs-primary-on-background',
                determineTextColor('#ffffff', this.location.skin.mainColour)
            );
        this.location.skin.mainColour &&
            document.documentElement.style.setProperty(
                '--rs-text-on-primary',
                determineTextColor(this.location.skin.mainColour, '#ffffff')
            );
        this.location.skin.mainColour &&
            document.documentElement.style.setProperty(
                '--rs-text-on-secondary',
                determineTextColor(this.location.skin.mainColour, '#d9d9d9')
            );
    }
}
